import { gql } from '@apollo/client';

export const ADD_CUSTOM_STAGES = gql`
  mutation AddCustomStagesMutation($data: CreateStageInput!) {
    createStage(data: $data) {
      id
      name
    }
  }
`;
